import { CSSProperties } from 'react';

export type Widths = {
  width: CSSProperties['width'];
  minWidth: CSSProperties['minWidth'];
  maxWidth: CSSProperties['maxWidth'];
};

export type PredefinedColumns = 'checkbox' | 'dnd' | 'scrollbar-gutter';

/**
 * Default <th /> values are
 * @param width = 'auto'
 * @param minWidth = '0px'
 * @param maxWidth = 'none'
 */
export const createColumnWidths = (
  width: Widths['width'] = 'auto',
  minWidth: Widths['minWidth'] = '0px',
  maxWidth: Widths['maxWidth'] = 'none'
): Widths => {
  return { width, minWidth, maxWidth };
};

export const createPredefinedColumnWidths = (
  type: PredefinedColumns
): Widths => {
  switch (type) {
    case 'checkbox': {
      return createColumnWidths('24px', '24px', '24px');
    }
    case 'dnd': {
      return createColumnWidths('24px', '24px', '24px');
    }
    case 'scrollbar-gutter': {
      return createColumnWidths('10px', '10px', '10px');
    }
    default: {
      const _exhaustiveCheck: never = type;
      throw new Error('Invalid column type value');
    }
  }
};

export const createColumnsWidths = <Columns extends string>(
  columnWidths: Record<Columns, Widths>
): Record<Columns, Widths> => {
  return columnWidths;
};
